const runGetIterableEmailIdFromTheUrl = require("./runGetIterableEmailIdFromTheUrl");
const runGetIterableEmailIdFromTheSessionStorage = require("./runGetIterableEmailIdFromTheSessionStorage");

/**
 * @return {string}
 */
module.exports = function runGetIterableEmailIdInputInitValue() {
  let emailId = runGetIterableEmailIdFromTheUrl();

  if (!emailId) {
    emailId = runGetIterableEmailIdFromTheSessionStorage();
  }

  if (!emailId) {
    emailId = "not set";
  }

  return emailId;
};
